export default __webpack_public_path__ + "./fonts/MagicReplyLogo.448c2e7c.svg";